import { useQuery } from "@tanstack/react-query"
import { TrainingPermissionGet } from "../app/models/TrainingPermission"
import { digitalManagerApi } from "../services/api"

export function useTrainingPermissions(trainingId?: string) {
  const { data: trainingPermissions = [], isLoading: isLoadingTrainingPermissions } =
    useQuery({
      queryKey: ["trainingPermissions", trainingId],
      queryFn: () =>
        digitalManagerApi
          .get<TrainingPermissionGet[]>(`/trainings/${trainingId}/permissions`)
          .then((r) => r.data),
      enabled: !!trainingId,
    })

  return {
    trainingPermissions,
    isLoadingTrainingPermissions,
  }
}
